import { LogLevel } from '@azure/msal-browser';

let redirectUri = null;

if (process.env.NODE_ENV == 'production') {
    redirectUri = process.env.REACT_APP_REDIRECTURI_PRODUCTION;
} else {
    redirectUri = process.env.REACT_APP_REDIRECTURI_DEV;
}

export const msalConfig = {
    auth: {
        clientId: "68101bf8-9092-44cb-ab7c-2ab297674b92",
        authority: "https://login.microsoftonline.com/43007ff5-0887-4e53-b014-4ac3ca035328",
        redirectUri: redirectUri,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you're having issues on Internet Explorer 11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPII) => {
                if (containsPII) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const protectedResources = {
    apiTodoList: {
        endpoint: "http://localhost:5000/api/users",
        scopes: {
            // write: [ "api://f16a37fc-a521-4801-8610-62b5fe4ef38a/Users.ReadWrite" ]
            write: [ "api://f16a37fc-a521-4801-8610-62b5fe4ef38a/Users.Admin" ]
        }
    }
};

// Add scopes for the ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: [ "api://f16a37fc-a521-4801-8610-62b5fe4ef38a/access_via_approle_assignments" ]
};